import BBQChickenImage from './BBQchicken.webp';
import BraccioDiFerroImage from './BraccioDiFerro.webp';
import BufalinaImage from './Bufalina.webp';
import CalabreseImage from './Calabrese.webp';
import CapricciosaImage from './Capricciosa.webp';
import CalzoneImage from './Calzone.webp';
import DellaCasaImage from './DellaCasa.webp';
import ErbacceImage from './Erbacce.webp';
import GamberoniImage from './Gamberoni.webp';
import GustosaImage from './Guestosa.webp';
import HawaiiImage from './Hawai.webp';
import MargaritaKidsImage from './MargaritaKids.webp';
import MargheritaImage from './Margharita.webp';
import MafiosiImage from './Mafiosi.webp';
import MilanoImage from './Milano.webp';
import MontanaImage from './Montana.webp';
import NapoliImage from './Napoli.webp';
import OSoleMioImage from './OsoleMio.webp';
import PrimaveraImage from './Primavera.webp';
import ProsciuttoImage from './Prosciutto.webp';
import ProsciuttoKidsImage from './ProsciuttoKids.webp';
import ProsciuttoFunghiImage from './ProsciuttoFunghi.webp';
import QuattroFormaggiImage from './QuattroFormaggi.webp';
import QuattroStagioniImage from './QuattroStagioni.webp';
import RiinaImage from './Rinna.webp';
import RosemaryKidsImage from './RosemaryKids.webp';
import RusticaImage from './Rustica.webp';
import SalamiImage from './Salami.webp';
import TarantinaImage from './Tarantina.webp';
import TonnoImage from './Tonno.webp';
import TricoloreImage from './Tricolora.webp';
import VegetariaImage from './VegetariaUno.webp';
import ZoloImage from './Zolo.webp';
import PomedoroKidsImage from './PomedoroKids.webp';
import FormaggioKidsImage from './FormaggioKids.webp';
import SallamiKidsImage from './SalamiKids.webp';

export const PIZZA_ASSET_IMAGES = {
  bbqChicken: BBQChickenImage,
  braccioDiFerro: BraccioDiFerroImage,
  bufalina: BufalinaImage,
  margaritaKids: MargaritaKidsImage,
  mafiosi: MafiosiImage,
  margherita: MargheritaImage,
  milano: MilanoImage,
  prosciutto: ProsciuttoImage,
  prosciuttoKids: ProsciuttoKidsImage,
  salami: SalamiImage,
  prosciuttoFunghi: ProsciuttoFunghiImage,
  hawaii: HawaiiImage,
  capricciosa: CapricciosaImage,
  erbacce: ErbacceImage,
  calzone: CalzoneImage,
  tarantina: TarantinaImage,
  tricolore: TricoloreImage,
  quattroStagioni: QuattroStagioniImage,
  quattroFormaggi: QuattroFormaggiImage,
  tonno: TonnoImage,
  napoli: NapoliImage,
  gustosa: GustosaImage,
  montana: MontanaImage,
  calabrese: CalabreseImage,
  dellaCasa: DellaCasaImage,
  gamberoni: GamberoniImage,
  oSoleMio: OSoleMioImage,
  primavera: PrimaveraImage,
  riina: RiinaImage,
  rustica: RusticaImage,
  vegetaria: VegetariaImage,
  salamiKids: SallamiKidsImage,
  rosemaryKids: RosemaryKidsImage,
  pomedoroKids: PomedoroKidsImage,
  formaggioKids: FormaggioKidsImage,
  zolo: ZoloImage,
};
